(function(){
	const progressBar = document.getElementById('blog-article-progress');
	const articleColumn = document.getElementById('blog-article-column');
	

	
	if(progressBar) {

		let targetY = window.innerHeight;
		let targetZero = articleColumn.getBoundingClientRect().bottom - targetY;

		window.addEventListener('scroll', function() {
			setProgress();
		});

		const setProgress = () => {
			let difference = articleColumn.getBoundingClientRect().bottom - targetY;
			let ratio = 1 - difference / targetZero;
			progressBar.setAttribute('value', ratio);
		}

	}
})();